window.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".featured-collection-section .Carousel")
    .forEach((carousel) => {
      let flkty = Flickity.data(carousel);

      if (!flkty) return;
      let wasDragging = false;

      flkty.on("dragStart", () => {
        wasDragging = true;
      });

      flkty.on("settle", () => {
        setTimeout(() => {
          wasDragging = false;
        }, 0);
      });

      carousel.addEventListener(
        "click",
        (e) => {
          if (wasDragging) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
          }
        },
        true,
      );
    });
});
